// Free shipping progress indicator for cart drawer
(() => {
  const THRESHOLD = 500;
  const currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || "DKK";
  const fmt = new Intl.NumberFormat("da-DK", { style: "currency", currency });

  const getContainer = () => document.querySelector(".cart__blocks");
  const ensureNode = (c) => {
    let n = c.querySelector(".free-shipping-message");
    if (!n) { n = document.createElement("div"); n.className = "free-shipping-message"; c.prepend(n); }
    return n;
  };

  const getTotal = async () => {
    const r = await fetch("/cart.js", { credentials: "same-origin" });
    const cart = await r.json();
    return (cart.items_subtotal_price ?? cart.total_price) / 100;
  };

  const render = async () => {
    const c = getContainer(); if (!c) return;
    const n = ensureNode(c);
    try {
      const total = await getTotal();
      const remaining = Math.max(0, THRESHOLD - total);
      n.textContent = remaining <= 0
        ? "Wuhuu! – Du har opnået gratis levering"
        : `Køb for ${fmt.format(remaining)} mere, og få gratis levering`;
      n.setAttribute("aria-live", "polite");
    } catch { /* ignore */ }
  };

  document.addEventListener("DOMContentLoaded", render);
  document.addEventListener("cart:updated", render);
  document.addEventListener("change", (e) => {
    const t = e.target;
    if (t && (t.name === "updates[]" || t.classList.contains("quantity__input"))) setTimeout(render, 150);
  });
})();

// Dropdown on hover for desktop
  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });
